import {Component, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

import {MaterialModule} from '../../../material.module';
import {
  RuntimeCapabilities,
  RuntimeCapabilitiesService,
} from '../../../services/enrich/runtime-capabilities.service';

@Component({
  selector: 'app-enrich-runtime-status',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './runtime-status.component.html',
  styleUrls: ['./runtime-status.component.scss'],
  host: {class: 'webinars-m3 webinars-shell'},
})
export class EnrichRuntimeStatusComponent {
  private readonly runtimeCapabilitiesService = inject(RuntimeCapabilitiesService);

  isLoading = true;
  isUnavailable = false;
  runtime: RuntimeCapabilities | null = null;

  constructor() {
    this.runtimeCapabilitiesService
      .getRuntimeCapabilities()
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: (runtime) => {
          this.runtime = runtime;
          this.isLoading = false;
        },
        error: () => {
          this.runtime = null;
          this.isUnavailable = true;
          this.isLoading = false;
        },
      });
  }

  readinessLabel(readiness: RuntimeCapabilities['readiness']): string {
    if (readiness === 'ready') return 'Metadata validation ready';
    if (readiness === 'failed') return 'Metadata validation failed';
    return 'Metadata validation starting';
  }
}
